<section class="format">
  <div class="fieldArea">
    <ng-container [formGroup]="editForm">
      <div
        *ngFor="let field of formFields"
        id="{{ field.name }}"
        style="width: 98%"
      >
        <ng-container *ngIf="field.displayType == 'select'">
          <ng-container>
            <label>{{ field.label }}:</label>
            <!-- For SELECT type of fields (single and multiple)-->
            <mat-form-field appearance="fill" style="width: 65%">
              <mat-select
                [formControlName]="field.name"
                placeholder="Please select an option"
                floatPlaceholder="never"
                (selectionChange)="buildAggregateData()"
              >
                <mat-option
                  *ngFor="let item of field.options.data"
                  [value]="item.value"
                  [disabled]="item.disabled"
                >
                  {{ item.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!-- end SELECT-->
          </ng-container>
        </ng-container>

        <ng-container *ngIf="field.displayType == 'text'">
          <ng-container>
            <label *ngIf="chartType != 'Bar'">{{ field.label }}:</label>
            <label
              *ngIf="
                chartType == 'Bar' &&
                field.name != 'yAxisValue' &&
                field.name != 'xAxisValue'
              "
              >{{ field.label }}:</label
            >
            <label *ngIf="chartType == 'Bar' && field.name == 'yAxisValue'"
              >Bottom Title:</label
            >
            <label *ngIf="chartType == 'Bar' && field.name == 'xAxisValue'"
              >Left Title:</label
            >
            <!-- For TEXT type of fields-->
            <mat-form-field appearance="fill" style="width: 65%">
              <input
                matInput
                [formControlName]="field.name"
                name="{{ field.name }}"
                type="text"
                (change)="buildAggregateData()"
              />
            </mat-form-field>
            <!-- end TEXT & NUMBER -->
          </ng-container>
        </ng-container>
        <ng-container *ngIf="field.displayType == 'slide-toggle'">
          <ng-container>
            <label class="slide">{{ field.label }}:</label>
            <!-- For SLIDER type of fields-->
            <mat-slide-toggle
              color="primary"
              [formControlName]="field.name"
              name="{{ field.name }}"
              (change)="buildAggregateData()"
            >
            </mat-slide-toggle>
            <!-- end SLIDER -->
          </ng-container>
        </ng-container>

        <ng-container *ngIf="field.displayType == 'textarea'">
          <ng-container>
            <label>{{ field.label }}:</label>
            <!-- For TEXTFIELD type of fields-->
            <mat-form-field
              appearance="fill"
              style="width: 65%"
              class="textarea"
            >
              <textarea
                matInput
                [formControlName]="field.name"
                name="{{ field.name }}"
                type="{{ field.displayType }}"
                (change)="buildAggregateData()"
              ></textarea>
            </mat-form-field>
            <!-- end TEXTFIELD-->
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</section>
